"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

/** @optimized using svgo:^3.0.2 */
export const SmallBatch = createSVGIcon(
  <>
    <title>Small Batch</title>
    <path
      d="M11.878 22.455 2.729 11.952 6.617 7.72h10.955l3.459 4.233zM2.749 11.952h18.267"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.858 22.353 8.283 12.137a.78.78 0 0 1 .01-.535l1.422-3.63M11.912 22.465l4.058-10.337a.78.78 0 0 0 .024-.492L14.87 7.724M5.75 2.658l.97 2.114M11.883 3.54V1.143M.571 6.55l2.056.745M18.01 2.658l-.974 2.114M23.189 6.55l-2.06.745"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "SmallBatch",
  { viewBox: "0 0 24 24", titleAccess: "SmallBatch", fill: "none" }
);
